module.exports = __webpack_public_path__ + "static/media/hipercard.2097d64a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/hipercard.png
// module id = 1108
// module chunks = 0